const quotaRoutes = [

    {
        path: '/quota',
        name: 'QuotaUsagePage',
        component: () => import('../views/quota/QuotaUsageComponent.vue'),
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
            module: 'quota',
        },
    },

];

export default quotaRoutes;
